
export default class Connection {
	constructor(id, cscom) {
		if (!(this instanceof Connection)) {
			return new Connection(id, cscom);
		}
		this.cscom = cscom;
		this.id = id;

		if (this.id) {
			this.path = `/user-site-api/connections/${this.id}`;
		} else {
            this.path = `/user-site-api/connections`;
		}
	}

    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }

	list(data) {
        return this.cscom.req.get(this.path, null, data);
	}

	listAll() {
        return this.cscom.req.get(this.path, { limit: 9999 }).then((result) => {
			return result._embedded.items;
		});
	}

	update(body) {
		return this.cscom.req.put(this.path, body).then((result) => {
			return result;
		});
	}
	
	add(body) {
		return this.cscom.req.post(this.path, body).then((result) => {
			return result;
		});
	}

	remove() {
		return this.cscom.req.del(this.path).then((result) => {
			return result;
		});
	}

	import(data) {
        return this.cscom.req.get(this.path + "/import", data);
    }

	forceCreateSyncOperation(data){
		return this.cscom.req.put(this.path + "/forceCreateSyncOperation", data);
	}

    exportSale(saleId) {
        return this.cscom.req.get(this.path + "/exportSale", { saleId });
	}

    exportNewSales(saleId) {
        return this.cscom.req.get(this.path + "/exportNewSales");
    }

    getSalesMeta() {
        return this.cscom.req.get(this.path + "/getSalesMeta");
    }

    test(data) {
        return this.cscom.req.get(this.path + "/test", data);
	}

	testBCWebhookOrderCreation(data) {
		return this.cscom.req.post(this.path + "/testBCWebhookOrderCreation", data).then((result) => {
			return result;
		});
	}

	testWebhookOrderCreation(data) {
		return this.cscom.req.post(this.path + "/testWebhookOrderCreation", data).then((result) => {
			return result;
		});
	}

	deleteWebhook(data) {
		return this.cscom.req.post(this.path + "/deleteWebhook", data).then((result) => {
			return result;
		});
	}

	location(data) {
        return this.cscom.req.get(this.path + "/location", data);
	}

	export(data) {
        return this.cscom.req.get(this.path + "/export", data);
	}

	importPaymentTypes(data) {
		return this.cscom.req.post(this.path + "/importPaymentTypes", data).then((result) => {
			return result;
		});
	}

	migrate(data) {
        return this.cscom.req.get(this.path + "/shopifyGraphqlMigrate", data);
    }
}
